import { useMsal } from '@azure/msal-react';
import { useEffect } from 'react';
import { getLangCode } from '../../utilities/getLangCode';

const CallbackComponent = () => {
  const { instance } = useMsal();
  const getstoredData = (key: string) => {
    const savedData = localStorage.getItem(key);
    if (!savedData) return null;
    try {
      const parsedData = JSON.parse(atob(savedData));
      return parsedData;
    } catch (error) {
      localStorage.removeItem(key);
      return null;
    }
  };

  useEffect(() => {
    // Check for a logout query parameter '?logout=true' that indicates logout
    const urlParams = new URLSearchParams(window.location.search);
    const logoutSuccess = urlParams.get('logout') === 'true';
    // Prefer locale from state (lc=...) if present, else derive from URL
    let locale = getLangCode();
    const stateParam = urlParams.get('state');
    if (stateParam) {
      try {
        const decodedState = decodeURIComponent(stateParam);
        const lcMatch = decodedState.match(/(?:^|&)lc=([^&]+)/);
        if (lcMatch && lcMatch[1]) {
          locale = lcMatch[1];
        }
      } catch (e) {
        // ignore state parsing errors and fall back to URL-derived locale
      }
    }

    if (logoutSuccess) {
      localStorage.removeItem('authToken'); // TODO - check if its required
      sessionStorage.removeItem('authToken'); // TODO - check if its required
      sessionStorage.setItem('isLogin', 'false');
      sessionStorage.removeItem('apiOfferTypes');
      sessionStorage.setItem('newOfferType','');
      sessionStorage.removeItem("oiduser");
      sessionStorage.removeItem("tiduser");
      sessionStorage.removeItem("ISVEnrolled");
      sessionStorage.removeItem("isCMP");
      sessionStorage.removeItem("isMAICPP");
      sessionStorage.removeItem("userdomain");
      localStorage.removeItem("authenticateduser");
      localStorage.removeItem("newuser");
      sessionStorage.removeItem("acknowledgement");
      localStorage.removeItem("offerTypeSet");
      localStorage.removeItem("isResult");
      localStorage.removeItem("cmpStatus");
      localStorage.removeItem("m365CopilotStatus");
      localStorage.removeItem("publishStatus");
      sessionStorage.removeItem("ISVEnrolled");
      sessionStorage.removeItem("isCMPActive");
      localStorage.removeItem("appAdvisorGuidedTourSeen");
      localStorage.removeItem("mloAutoOpen");
      instance.clearCache().then(() => {
        // TODO: to be updated for all locales during global sdc launch, Adding only to en-us locale, dev and prod as PPE does not support new sdc cdn urls
        if (
          process.env.REACT_APP_ANALYTICS_ENV !== "ppe"
        ) {
          window.location.href = `${process.env.REACT_APP_PROD_URI}/${locale}/software-development-companies/app-advisor`;
        } else {
          window.location.href = `${process.env.REACT_APP_PROD_URI}/${locale}/isv/marketplace-app-advisor/my-results`;
        }
      })
    } else {
      // Login redirection or Fallback if logout was not successful
      const resultLocalStorage = getstoredData('appadvisor-turboflow-result');
      if (resultLocalStorage?.currentStage === "PUBLISH" && resultLocalStorage?.currentEnStepTitle === "start-your-marketplace-offer") {
        // TODO: to be updated for all locales during global sdc launch, Adding only to en-us locale, dev and prod as PPE does not support new sdc cdn urls
        if (
          process.env.REACT_APP_ANALYTICS_ENV !== "ppe"
        ) {
          window.location.href = `/${locale}/software-development-companies/app-advisor/guidance/my-results?stage=publish&step=start-your-marketplace-offer`;
        } else {
          window.location.href = `/${locale}/isv/marketplace-app-advisor/my-results?stage=publish&step=start-your-marketplace-offer`;
        }
      }
      else {
        // TODO: to be updated for all locales during global sdc launch, Adding only to en-us locale, dev and prod as PPE does not support new sdc cdn urls
        if (
          process.env.REACT_APP_ANALYTICS_ENV !== "ppe"
        ) {
          window.location.href = `/${locale}/software-development-companies/app-advisor/guidance/my-results`;
         } else {
          window.location.href = `/${locale}/isv/marketplace-app-advisor/my-results`;
        }
      }
    }
  }, [instance]);

  return null; // No render required as it just handles the redirection of page
};

export default CallbackComponent;